import React from 'react';
import CalendarProvider from './context/CalendarProvider';
import EventProvider from './context/EventProvider';
import BigCalendarSection from '../../components/Activity/BigCalendarSection/BigCalendarSection';
import SmallCalendarSection from '../../components/Activity/SmallCalendarSection/SmallCalendarSection';
import './Activity.scss';

function Activity() {
  document.title = 'Employee Activity | Envision Daikin';
  return (
    <CalendarProvider>
      <EventProvider>
        <div className="activity-page">
          <div
            style={
              {
                // minHeight: '90vh',
              }
            }
          >
            <div className="px-3 py-2">
              <div className="mb-1 pt-1 activity-header">
                <span className="activity-title">Employee Activity</span>
              </div>
              <div className="d-flex calendar-wrapper">
                <div className="small-calendar">
                  <SmallCalendarSection />
                </div>
                <div
                  className="big-calendar"
                  style={{
                    position: 'relative',
                  }}
                >
                  <BigCalendarSection />
                </div>
              </div>
            </div>
          </div>
        </div>
      </EventProvider>
    </CalendarProvider>
  );
}

export default Activity;
